import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { Reveal, SectionHead, Accent } from "@/components/Reveal";

const Services = () => (
  <section data-testid="services-section" className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
    <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
      <SectionHead
        eyebrow="What We Do"
        title={<>Three ways to <Accent>wander</Accent> with us</>}
        text="Tours across India, a chauffeur on call, or a passport-ready escape — one team handles it all."
      />
    </div>
    <div className="grid md:grid-cols-3 gap-6">
      {SERVICES.map((s, i) => (
        <Reveal key={s.id} delay={i * 0.1}>
          <Link
            to={s.link}
            data-testid={s.testid}
            className="card-lift group block rounded-3xl overflow-hidden border border-white/10 bg-[#121820]"
          >
            <div className="relative h-64 overflow-hidden">
              <img
                src={s.image}
                alt={s.title}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#121820] via-transparent to-transparent" />
            </div>
            <div className="p-7">
              <h3 className="font-sora text-xl font-bold">
                {s.title} <span className="font-playfair italic font-medium text-[#F2C230]">· {s.accent}</span>
              </h3>
              <p className="text-sm text-[#F5F5F0]/60 leading-relaxed mt-3">{s.description}</p>
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#3FB6D3] mt-5 group-hover:gap-3 transition-[gap] duration-300">
                {s.cta} <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />
              </span>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Services;
